import React from 'react';

interface ContentCard {
    type: 'newsletter' | 'podcast' | 'discord' | 'youtube';
    title: string;
    description: string;
    icon: string;
    cta: string;
    link: string;
    stats?: string;
}

interface ContentHubProps {
    cards: ContentCard[];
    className?: string;
}

export const ContentHub: React.FC<ContentHubProps> = ({
    cards,
    className = '',
}) => {
    return (
        <div className={`curator-content-hub ${className}`}>
            {cards.map((card, index) => (
                <a
                    key={index}
                    href={card.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="curator-content-card"
                >
                    <div className="curator-content-icon">{card.icon}</div>
                    <div className="curator-content-title">{card.title}</div>
                    <div className="curator-content-desc">
                        {card.description}
                        {card.stats && <span> • {card.stats}</span>}
                    </div>
                    <div className="curator-content-cta">{card.cta} →</div>
                </a>
            ))}
        </div>
    );
};

export default ContentHub;
